export default "__VITE_ASSET__Cwd456RC__"